"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIPO_ENVIO_SMS_COLAS = void 0;
exports.TIPO_ENVIO_SMS_COLAS = {
    TELESTAR: 1,
    INDUSTEL: 2,
    AMBOS: 3,
};
